import { motion } from 'framer-motion';
import './About.css';

const highlights = [
  {
    number: '01',
    title: 'Backend engineering',
    detail: 'Java, Spring Boot, REST APIs, SQL, and application security.',
    tags: ['Java', 'Spring Boot', 'REST APIs']
  },
  {
    number: '02',
    title: 'Production impact',
    detail: 'At Paperbill Tech, delivered 5–6 features and reduced slow MySQL query time by about 25%.',
    tags: ['Feature delivery', 'MySQL', 'Testing']
  },
  {
    number: '03',
    title: 'Client delivery',
    detail: 'For PhysioWaye, documented 30+ REST APIs and added automated quality checks to CI/CD.',
    tags: ['OpenAPI', 'GitHub Actions', 'Jest']
  }
];

export default function About() {
  return (
    <motion.section
      id="about"
      aria-labelledby="about-heading"
      className="about-section relative overflow-hidden px-6 py-16 md:px-20"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
    >
      <motion.div
        aria-hidden="true"
        className="about-glow absolute left-1/2 top-0 -translate-x-1/2 rounded-full blur-3xl"
        animate={{ scale: [1, 1.12, 1] }}
        transition={{ duration: 10, repeat: Infinity, ease: 'easeInOut' }}
      />

      <div className="relative z-10 mx-auto max-w-5xl">
        <motion.div
          className="about-intro mx-auto mb-10 max-w-3xl text-center"
          initial={{ y: 18, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
        >
          <p className="section-eyebrow">A little about me</p>
          <h2 id="about-heading" className="mb-4 text-4xl font-bold text-gray-900 dark:text-white">
            Backend-focused software engineer
          </h2>
          <p className="text-lg leading-relaxed text-gray-700 dark:text-gray-300">
            I build dependable APIs and full-stack products, with experience delivering production features,
            improving database performance, and taking projects from implementation to deployment.
          </p>
          <div className="about-credential" aria-label="Education">
            MCA · The Oxford College of Engineering · CGPA 9.45 · VTU, 2025
          </div>
        </motion.div>

        <div className="grid gap-4 md:grid-cols-3">
          {highlights.map((item, index) => (
            <motion.article
              key={item.number}
              className="about-highlight-card"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -5 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: index * 0.1 }}
            >
              <span className="about-card-number">{item.number}</span>
              <h3>{item.title}</h3>
              <p>{item.detail}</p>
              <ul className="about-tags" aria-label={`${item.title} focus areas`}>
                {item.tags.map((tag) => <li key={tag}>{tag}</li>)}
              </ul>
            </motion.article>
          ))}
        </div>
      </div>
    </motion.section>
  );
}
